import { worktags } from '../Common/enum';
const worktagsLength = Object.keys(worktags).length;


const validate = (values) => {
    const errors = {};
    // console.log("********VALUES: IN validateJS",values);
    if(!values.type_code) {
      errors.type_code = 'Required';
    }
    if(!values.bank_account) {
        errors.bank_account = 'Required';
    }
    if(!values.customer_ref && !values.orig_id && !values.ind_id_no && !values.bo_customer && !values.matchBankAccountOnly && !values.vrn) {
        errors.customer_ref = 'At least one of the following must be defined (Customer Ref, Orig ID, Ind. ID No., B/O Customer, VRN)';
        errors.orig_id = 'At least one of the following must be defined (Customer Ref, Orig ID, Ind. ID No., B/O Customer, VRN)';
        errors.ind_id_no = 'At least one of the following must be defined (Customer Ref, Orig ID, Ind. ID No., B/O Customer, VRN)';
        errors.bo_customer = 'At least one of the following must be defined (Customer Ref, Orig ID, Ind. ID No., B/O Customer, VRN)';
        errors.vrn = 'At least one of the following must be defined (Customer Ref, Orig ID, Ind. ID No., B/O Customer, VRN)';
    }
    if((values.customer_ref || values.orig_id || values.ind_id_no || values.bo_customer || values.vrn) && values.matchBankAccountOnly) {
        errors.customer_ref = 'You can not enter any data for Customer Reference if the rule is for bank account only';
        errors.orig_id = 'You can not enter any data for Orig ID if the rule is for bank account only';
        errors.ind_id_no = 'You can not enter any data for Individual ID Number if the rule is for bank account only';
        errors.bo_customer = 'You can not enter any data for B/O Customer if the rule is for bank account only';
        errors.vrn = 'You can not enter any data for Virtual Reference Number if the rule is for bank account only';
    }

    if (!values.worktags || !values.worktags.length) {
        errors.worktags = { _error: 'At least one worktag must be entered' };
    } else {
        // console.log("WORKTAGS:", values.worktags);
        // console.log("values.worktags.length:", values.worktags.length);
        // console.log("worktagsLength:", worktagsLength);

        if (values.worktags.length > worktagsLength) {
            errors.worktags = { _error: `No more than ${worktagsLength} worktags can be defined you have ${values.worktags.length}.` };
        }
        const worktagsArrayErrors = []
        values.worktags.forEach((worktag, worktagIndex) => {
            const worktagErrors = {}
            if (!worktag || !worktag.key) {
                worktagErrors.key = 'Required';
                worktagsArrayErrors[worktagIndex] = worktagErrors;
            }
            if (!worktag || !worktag.value) {
                worktagErrors.value = 'Required';
                worktagsArrayErrors[worktagIndex] = worktagErrors;
            }
            
            let keys = values.worktags.map( (worktag) => worktag.key );
            if (keys.indexOf(worktag.key, keys.indexOf(worktag.key)+1) > -1){
                // console.log("Duplicate Error");
                worktagErrors.key = 'Duplicate';
                worktagsArrayErrors[worktagIndex] = worktagErrors;
            }
            
            return worktagErrors;
        });
       // console.log("validate props:",props) ;
        if(worktagsArrayErrors.length) {
            errors.worktags = worktagsArrayErrors;
        }
    }
    return errors;
  };
  
  export default validate;


// WEBPACK FOOTER //
// ./src/components/RuleForm/validate.js